export const SHELFY_CONDITION_OPTIONS = [
  {
    option: 'new-sealed',
    label: 'New / Sealed',
    aliases: ['newsealed', 'new / sealed', 'new-sealed'],
  },
  {
    option: 'new-unsealed',
    label: 'New / Unsealed',
    aliases: ['newunsealed', 'new / unsealed', 'new-unsealed'],
  },
  { option: 'like-new', label: 'Like New', aliases: ['likenew', 'like new', 'like-new'] },
  { option: 'excellent', label: 'Excellent', aliases: ['excellent'] },
  { option: 'very-good', label: 'Very Good', aliases: ['verygood', 'very good', 'very-good'] },
  { option: 'good', label: 'Good', aliases: ['good'] },
  {
    option: 'reading-copy',
    label: 'Reading Copy',
    aliases: ['readingcopy', 'reading copy', 'reading-copy'],
  },
];

export const SHELFY_FORMAT_OPTIONS = [
  { option: 'hardcover', label: 'Hardcover', aliases: ['hardcover', 'hard cover'] },
  { option: 'paperback', label: 'Paperback', aliases: ['paperback', 'softcover', 'soft cover'] },
];

export const SHELFY_GENRE_OPTIONS = [
  {
    option: 'fiction',
    label: 'Fiction',
    aliases: [
      'general fiction',
      'general-fiction',
      'literary',
      'literary fiction',
      'literary-fiction',
      'contemporary',
      'contemporary fiction',
      'contemporary-fiction',
    ],
  },
  { option: 'romance', label: 'Romance', aliases: ['dark romance', 'dark-romance'] },
  {
    option: 'fantasy',
    label: 'Fantasy',
    aliases: ['romantasy', 'dark romantasy', 'dark-romantasy'],
  },
  {
    option: 'mystery-thriller',
    label: 'Mystery & Thriller',
    aliases: ['mystery', 'thriller', 'mystery thriller', 'mystery / thriller'],
  },
  {
    option: 'historical-fiction',
    label: 'Historical Fiction',
    aliases: ['historical', 'historical fiction'],
  },
  { option: 'horror', label: 'Horror', aliases: ['horror'] },
  {
    option: 'scifi',
    label: 'Sci-Fi',
    aliases: ['sci fi', 'sci-fi', 'science fiction', 'science-fiction'],
  },
  {
    option: 'youngadult',
    label: 'Young Adult',
    aliases: ['young adult', 'young-adult', 'ya'],
  },
  {
    option: 'manga-graphic-novels',
    label: 'Manga & Graphic Novels',
    aliases: ['manga', 'graphic novels', 'manga and graphic novels'],
  },
  {
    option: 'non-fiction',
    label: 'Non-Fiction',
    aliases: ['nonfiction', 'non fiction'],
  },
  { option: 'classics', label: 'Classics', aliases: ['classic'] },
  { option: 'other', label: 'Other', aliases: ['other'] },
  {
    option: 'children',
    label: 'Children',
    aliases: ['kids', "kids' books", 'kids books', 'kids-books', "children's books", 'childrens-books'],
  },
];

// Compatibility export for existing My Shelf imports. All Shelfy genre controls share this array.
export const MY_SHELF_GENRE_OPTIONS = SHELFY_GENRE_OPTIONS;

const GENRE_SEARCH_VALUES = {
  fiction: ['fiction', 'general-fiction', 'literary-fiction', 'contemporary-fiction'],
  romance: ['romance', 'dark-romance'],
  fantasy: ['fantasy', 'romantasy', 'dark-romantasy'],
  'mystery-thriller': ['mystery-thriller', 'mystery', 'thriller'],
  scifi: ['scifi', 'science-fiction', 'sci-fi'],
  youngadult: ['youngadult', 'young-adult'],
  'non-fiction': ['non-fiction', 'nonfiction'],
  children: ['children', 'kids-books', 'childrens-books'],
};

export const normalizeOptionLabel = value =>
  String(value || '')
    .toLocaleLowerCase()
    .replace(/[\u2019']/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^\x00-\x7F]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');

export const optionForValue = (value, options = []) => {
  const normalized = normalizeOptionLabel(value);
  if (!normalized) return '';
  const match = options.find(option => {
    const aliases = [option.option, option.label, ...(option.aliases || [])];
    return aliases.some(alias => normalizeOptionLabel(alias) === normalized);
  });
  return match?.option || '';
};

export const canonicalGenreValue = value => optionForValue(value, SHELFY_GENRE_OPTIONS);

export const genreSearchValues = value => {
  const canonical = canonicalGenreValue(value);
  return canonical ? GENRE_SEARCH_VALUES[canonical] || [canonical] : [];
};

export const genreEnumOptionsForField = (key, schemaType, configuredOptions) =>
  ['genre', 'blinddategenre'].includes(key) && schemaType === 'enum'
    ? enumOptions(SHELFY_GENRE_OPTIONS)
    : configuredOptions;

export const canonicalGenreOptionsForValues = (values = []) => {
  const normalizedValues = new Set(
    values.filter(Boolean).map(value => canonicalGenreValue(value) || value)
  );
  const canonicalOptions = SHELFY_GENRE_OPTIONS.filter(option =>
    normalizedValues.delete(option.option)
  ).map(({ option, label }) => ({ option, label }));
  const otherOptions = [...normalizedValues]
    .sort((left, right) => left.localeCompare(right))
    .map(value => ({ option: value, label: value }));
  return [...canonicalOptions, ...otherOptions];
};

export const enumOptions = options => options.map(({ option, label }) => ({ option, label }));
